package com.ives.components.workspace;

import js.html.Element;
import com.ives.utils.math.Vector3D;

class OrientationSideLabel {
	public var element:Element;
	public var position:Vector3D;

	public function new(element:Element, position:Vector3D) {
		this.element = element;
		this.position = position;
	}
}
